/* Molecules */
import './components/m-competency-spider-detail.js';
import './components/m-filter-persons.js';
import './components/m-flyout-list-persons.js';
import './components/m-flyout-list-topics.js';
import './components/m-flyout-list.js';
import './components/m-form.js';
import './components/m-navigation.js';
import './components/m-person-groups.js';
import './components/m-publications.js';
import './components/m-quotes.js';
import './components/m-topics.js';

/* Organisms */
import './components/o-header.js';

const textareaAutosizeElements = document.querySelectorAll('.m-field__autoresize');

textareaAutosizeElements.forEach((grower) => {
	const textarea = grower.querySelector('textarea');
	textarea.addEventListener('input', () => {
		grower.setAttribute('data-replicated-value', textarea.value);
	});
});
